import { render, staticRenderFns } from "./SentimentFooter.vue?vue&type=template&id=3224a3c0&scoped=true&"
import script from "./SentimentFooter.vue?vue&type=script&lang=js&"
export * from "./SentimentFooter.vue?vue&type=script&lang=js&"
import style0 from "./SentimentFooter.vue?vue&type=style&index=0&id=3224a3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224a3c0",
  null
  
)

export default component.exports